import axios from "axios";
import { STORAGE_KEYS } from "./constants";

const handleError = (error) => {
  let err = { status: 500, message: "Something went wrong, please try again" };
  if (error.response) {
    err = {
      status: error.response.status,
      message: error.response.data?.message || "Something went wrong, please try again",
    };
    if (err.status === 401) {
      localStorage.removeItem(STORAGE_KEYS.token);
      localStorage.removeItem(STORAGE_KEYS.user);
      localStorage.removeItem(STORAGE_KEYS.store);
      window.location.href = "/login";
    } else if (err.status === 422) {
      err.errors = error.response.data?.errors;
    }
  }
  return Promise.reject(err);
};

// Every request gets a hard deadline: without one, a request that hangs
// instead of erroring (a dropped connection with no RST, a slow/flaky mobile
// path) leaves an `await apiClient...`/`await apiAuth...` call — e.g.
// AuthContext's login() — stuck forever with no error and no way for the UI
// to recover, since a plain network hang never rejects on its own. A timeout
// turns that into a normal axios error, which the interceptor below already
// knows how to surface.
const REQUEST_TIMEOUT_MS = 15000;

// Bearer-authenticated client for every request after login — mirrors
// denzo-pos's utils/http.js so the token/401 handling behaves identically.
export const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: { Accept: "application/json" },
  timeout: REQUEST_TIMEOUT_MS,
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem(STORAGE_KEYS.token);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

apiClient.interceptors.response.use((res) => res, handleError);

// No-auth client, for the login call itself.
export const apiAuth = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: { Accept: "application/json" },
  timeout: REQUEST_TIMEOUT_MS,
});

apiAuth.interceptors.response.use((res) => res, handleError);
